<template>
    <el-drawer
        :title="!id ? '新增专用模板' : '编辑专用模板'"
        :visible.sync="drawerShow"
        :wrapperClosable="false"
        :destroy-on-close="true"
        size="auto"
        @close="close"
    >
        <div class="drawer-content">
            <el-form
                :model="formData"
                ref="formData"
                label-position="top"
				:rules="rules"
            >
				<el-form-item prop="title" label="模板名称">
				    <el-input
				        placeholder="请输入模板名称"
				        v-model="formData.title"
				        maxlength="30"
				    ></el-input>
				</el-form-item>
				<el-form-item prop="types" label="业务分类">
					<el-cascader v-model="formData.types" :options="typeOptions" style="width: 100%;"></el-cascader>
					
				</el-form-item>
				<el-form-item prop="bindIds" label="绑定对象ID">
				    <el-input
				        placeholder="请输入绑定对象ID"
				        v-model="formData.bindIds"
				        maxlength="30"
						:disabled="id ? true : false"
				    ></el-input>
					<p><small>仅限当前演出使用这个模板</small></p>
				</el-form-item>
				<el-form-item prop="chineseContent" label="中文内容">
					<el-input v-model="formData.chineseContent" type="textarea" :rows="10"></el-input>
				</el-form-item>
				<el-form-item prop="englishContent" label="英文内容">
				    <el-input v-model="formData.englishContent" type="textarea" :rows="10"></el-input>
				</el-form-item>
            </el-form>
        </div>
        <div class="drawer-footer">
            <el-button @click="close">取 消</el-button>
            <el-button
                type="primary"
                @click="onSubmit"
                :loading="btnLoading"
                >确认</el-button
            >
        </div>
    </el-drawer>
</template>

<script>
import {fetchServiceTemplateType} from  '@/assets/js/commonApi'
export default {
    props:{
        activityId:{
            type:[Number,String],
            default: null
        },
    },
    data() {
        return {
            formData: {
                title: "",
                businessType: "",
                type:"",
                chineseContent: '',
                englishContent:'',
                types: [],
				bindIds:''
            },
            rules: {
                title: [{ required: true, message: "请输入服务模板名称" }],
                types: [{ required: true, message: "请选择业务分类"}],
                chineseContent: [{ required: true, message: "请输入中文条款"}],
                englishContent:[{ required: true, message: "请输入英文条款"}]
            },
            btnLoading: false,
            pageLoading: false,
            redirect: this.$route.query.redirect || "/system/serviceTemplate/list",
            reFresh:false,
            v: this.$route.query.v || '',
            // toolbar:['formatselect fontsizeselect | forecolor bold strikethrough | alignleft aligncenter alignright alignjustify | preview fullscreen'],
            // typeList: [],
            typeOptions: [],
			drawerShow:false,
			id:''
        };
    },
    
	mounted() {
		
	    const _typeList = fetchServiceTemplateType();
	    // const _orther = _typeList.filter((item) => item.value === 0);
		const _activity1= _typeList.filter((item) => item.value == 1 );
		const _activity2 = _typeList.filter((item) => item.value == 3 || item.value == 4 || item.value == 9 );
		const _activity3 = _typeList.filter((item) => item.value == 6 || item.value == 7);
	    this.typeOptions = [
	        { label: "服务说明", value: 1 , children: [..._activity1 ]},
			{ label: "购票须知", value: 2 , children: [..._activity2 ]},
			{ label: "观演须知", value: 3 , children: [..._activity3 ]},
	    ]
		
		
	},
    methods:{
        close() {
            this.drawerShow = false;
			this.$refs.formData.resetFields();
        },
        show(id,bindId){
            this.drawerShow = true;
        	this.id = id
        	this.formData.bindIds = bindId
        	if( this.id ){
        		this.getData();        		
        	}        	
        },
        // 获取详情
        getData() {
            this.pageLoading = true;
            this.$request({
                url: "/service/template/detail",
                method: "POST",
                params: { id: this.id },
            }).then((res) => {
                //处理成功回调
                const { state, msg, result } = res.data;
                if (state && state == 1 && result) {
                    this.formData = {
                        ...result,
                        types:[result.category, result.type]
                    }
                    this.reFresh = true;
                } else {
                    return this.$message.error(msg || "获取详情失败");
                }
            }).finally(() => {
                this.pageLoading = false;
            });
        },
        //表单提交
        onSubmit() {
			console.log(this.formData)
            this.$refs["formData"].validate((valid) => {
                if (valid) {
                    this.btnLoading = true;
                    this.$request({
                        url: !this.id ? "/service/template/create" : "/service/template/update",
                        method: "POST",
                        data: {
                            ...this.formData,
                            businessType:1,
                            type: this.formData.types[1],
							category:this.formData.types[0]
                        },
                    })
                        .then((res) => {
                            //处理成功回调
                            const { state, msg } = res.data;
                            if (state && state == 1) {
                                this.$message.success("操作成功");
                                this.$emit('onUpdate');
                                this.close();
                            } else {
                                return this.$message.error(msg || "操作失败");
                            }
                        })
                        .finally(() => {
                            this.btnLoading = false;
                        });
                }
            });
        },
        //返回
    }
    
}
</script>